module.exports = __webpack_public_path__ + "media/images/brain3new@2x-65281b7ee8cbe3dc2409385f71a50249.png";